import React, { useState, useEffect } from 'react'
import PublicInformationView from '../../Components/Auth/PublicInformationView'
import Form from 'Components/Form'
import { Textarea } from 'Components/Form/Textarea'
import SubmitButton from 'Components/Form/SubmitButton'
import {
  updateClientReferralProgramByCampaignId,
  getClientReferralProgramByCampaignId,
} from './gql'
import useGraphQLFetch from '../../Utils/Hooks/useGraphQLFetch'
import LoadingIndicator from '../../Components/LoadingIndicator/LoadingIndicator'
import { descriptions } from './options'

const NpsScoreVoterPage = () => {
  const [isShowForm, setIsShowForm] = useState(false)

  const urlParams = new URLSearchParams(window.location.search)
  const status = urlParams.get('status')
  const campaignId = urlParams.get('campaignId')
  const success = ['success', 'already-rated', 'already-verified'].includes(
    status,
  )
  const [description, setDescription] = useState(
    success ? descriptions.success : descriptions.error,
  )

  const title = `NPS Score ${success ? 'Successful' : 'Error'}`

  const { data: clientReferralProgram, isLoaded } = useGraphQLFetch({
    fetchFn: getClientReferralProgramByCampaignId,
    defaultFetchArgs: campaignId,
    mapResponse: data => data.campaign.clientReferralProgram,
  })

  useEffect(() => {
    if (isLoaded) {
      if (clientReferralProgram) {
        if (clientReferralProgram.feedback) {
          setDescription(descriptions.hasFeedback)
        } else {
          if (clientReferralProgram.score >= 6) {
            setIsShowForm(true)
          }
        }
      }
    }
  }, [isLoaded])

  const handleSubmit = async ({ feedback: { value } }) => {
    try {
      await updateClientReferralProgramByCampaignId({
        campaignId,
        feedback: value,
      })
      setIsShowForm(false)
      setDescription(descriptions.hasFeedback)
    } catch (e) {
      console.error({ e })
    }
  }

  const children = isLoaded ? (
    isShowForm ? (
      <Form onSubmit={handleSubmit}>
        <Textarea
          name="feedback"
          label="Feedback"
          placeholder="Please leave yor comment about campaign"
          initValue={''}
        />
        <br />
        <SubmitButton variant="contained" value="Send" />
      </Form>
    ) : null
  ) : (
    <LoadingIndicator />
  )

  return (
    <PublicInformationView
      title={title}
      description={description}
      children={isShowForm ? children : null}
    />
  )
}

export default NpsScoreVoterPage



// WEBPACK FOOTER //
// ./src/Containers/NpsScoreVotedPage/index.js